<!-- Footer Start -->
<div class="container-fluid footer bg-dark">
  <div class="container pt-5 pb-4">
    <div class="row g-5">
      
      <!-- Brand & About -->
      <div class="col-lg-3 col-md-6">
        <a routerLink="/">
          <h2 class="text-white fw-bold d-block">Job<span class="color-secondary">Son</span></h2>
        </a>
        <p class="mt-4 text-light">Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta facere delectus qui placeat inventore consectetur repellendus optio debitis.</p>
        <div class="d-flex hightech-link">
          <a href="#." class="btn-light nav-fill btn btn-square rounded-circle me-2"><i class="fab fa-facebook-f color-dark"></i></a>
          <a href="#." class="btn-light nav-fill btn btn-square rounded-circle me-2"><i class="fab fa-x-twitter color-dark"></i></a>
          <a href="#." class="btn-light nav-fill btn btn-square rounded-circle me-2"><i class="fab fa-instagram color-dark"></i></a>
          <a href="#." class="btn-light nav-fill btn btn-square rounded-circle me-0"><i class="fab fa-linkedin-in color-dark"></i></a>
        </div>
      </div>

      <!-- Quick Links -->
      <div class="col-lg-3 col-md-6">
        <h5 class="color-secondary">Useful Links</h5>
        <div class="mt-4 d-flex flex-column short-link">
          <a 
            *ngFor="let link of quickLinks" 
            [routerLink]="link.url" 
            class="mb-2 text-white">
            <i class="fas fa-angle-right color-secondary me-2"></i>{{ link.label }}
          </a>
        </div>
      </div>

      <!-- Help Links -->
      <div class="col-lg-3 col-md-6">
        <h5 class="color-secondary">Help & Policy</h5>
        <div class="mt-4 d-flex flex-column help-link">
          <a 
            *ngFor="let link of helpLinks" 
            [routerLink]="link.url" 
            class="mb-2 text-white">
            <i class="fas fa-angle-right color-secondary me-2"></i>{{ link.label }}
          </a>
        </div>
      </div>

      <!-- Contact Info -->
      <div class="col-lg-3 col-md-6">
        <h5 class="color-secondary">Contact Us</h5>
        <div class="text-white mt-4 d-flex flex-column contact-link">
          <a href="#" class="pb-3 text-light border-primary"><i class="fas fa-map-marker-alt color-secondary me-2"></i> 123 Street, New York, USA</a>
          <a href="tel:+1234567890" class="py-3 text-light border-primary"><i class="fas fa-phone-alt color-secondary me-2"></i> +123 456 7890</a>
          <a href="mailto:info@exmple.con" class="py-3 text-light border-primary"><i class="fas fa-envelope color-secondary me-2"></i> info&#64;exmple.con</a>
        </div>
      </div>

    </div>

    <hr class="text-light mt-5 mb-4">

    <!-- Copyright -->
    <div class="row">
      <div class="col-md-6 text-center text-md-start">
        <span class="text-light">© {{ currentYear }}, All Rights Reserved. Designed By <a href="https://themeforest.net/user/designsninja/portfolio" target="_blank">DesignsNinja</a></span>
      </div>
    </div>
  </div>
</div>
<!-- Footer End -->